package com.example.mystybag.login.model

enum class KeyButtonType(val value: String) {
    TYPE_0("0"),
    TYPE_1("1"),
    TYPE_2("2"),
    TYPE_3("3"),
    TYPE_4("4"),
    TYPE_5("5"),
    TYPE_6("6"),
    TYPE_7("7"),
    TYPE_8("8"),
    TYPE_9("9"),
    TYPE_DOT("."),
    TYPE_BACK("back"),
    TYPE_FINGERPRINT("finger"),
    TYPE_FACE("face"),
    TYPE_NONE("")
}